import config from '@plone/registry';

import type { ProductsSliderSlide } from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/schema';
import styles from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/styles.module.css';

const ImageSlide = ({
  slide_content,
}: Pick<ProductsSliderSlide, 'slide_content'>) => {
  const Image = config.getComponent('Image').component;

  return (
    <Image
      alt={slide_content.title}
      item={slide_content}
      className={styles.image}
    />
  );
};

export default ImageSlide;
